import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacypolicy from './pages/Privacypolicy';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col font-sans bg-slate-700">
        
        {/* Header */}
        <header className="flex items-center p-4 bg-slate-400 shadow">
          <img
            src="/nestquest_logo.png"
            alt="NestQuest Logo"
            className="h-12 w-12 rounded-full object-cover"
            style={{ imageRendering: 'crisp-edges' }}
          />
          <nav className="ml-6 space-x-4">
            <Link to="/" className="text-white hover:text-blue-600 font-bold text-lg">Home</Link>
            <Link to="/about" className="text-white hover:text-blue-600 font-bold text-lg">About</Link>
            <Link to="/contact" className="text-white hover:text-blue-600 font-bold text-lg">Contact</Link>
            <Link to="/privacy" className="text-white hover:text-blue-600 font-bold text-lg">Privacypolicy</Link>
          </nav>
        </header>

        {/* Page Content */}
        <main className="flex-grow p-6">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacypolicy />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-slate-900 text-slate-300 text-center py-4">
          <p className="text-sm">
            COPYRIGHT © {new Date().getFullYear()} BY NESTQUEST TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
          </p>
        </footer>

      </div>
    </Router>
  );
}

export default App;
